import styled, { css } from 'styled-components';

const Navbar = styled('div')(({ theme: { olist: theme } }) => css `
    position: sticky;
    display: flex;
    overflow: hidden;
    align-items: center;
    justify-content: space-between;
    min-height: 48px;
    width: 100%;
    padding: 0 ${theme.spacing.inset.small};
    top: 0;
    background-color: transparent;
  `);

export { Navbar };
